import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Opportunity } from './opportunityStore';

/**
 * 商機看板的資料（另外抓全部商機，不是列表 store 的那一頁）：persist 讓再次進來先顯示上次的看板、背景重抓
 * 原本先用列表那一頁（20 筆）分組、抓回全部再換掉，每一欄的筆數和金額每次進來都會跳一下
 * items 為 null＝從沒抓過（先用列表那一頁顯示）
 */
interface OpportunityBoardState {
  items: Opportunity[] | null;
  /** 後端回報的商機總數：超過看板上限時顯示提示 */
  total: number;
  setBoard: (items: Opportunity[], total: number) => void;
  updateItems: (update: (items: Opportunity[]) => Opportunity[]) => void;
}

export const useOpportunityBoardStore = create<OpportunityBoardState>()(
  persist(
    (set) => ({
      items: null,
      total: 0,
      setBoard: (items, total) => set({ items, total }),
      updateItems: update => set(state => ({ items: update(state.items ?? []) })),
    }),
    { name: 'crm-opportunity-board', partialize: state => ({ items: state.items, total: state.total }) }
  )
);
